<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { X } from 'lucide-vue-next';

defineProps<{
  title: string;
  closeLabel: string;
  contentClass?: HTMLAttributes['class'];
  triggerClass?: HTMLAttributes['class'];
  hideClose?: boolean;
}>();

const open = defineModel<boolean>('open', { default: false });
</script>

<template>
  <UiSheet v-model:open="open">
    <!-- .stop: a clickable ancestor (e.g. the result-card leg) must not open a second overlay. -->
    <UiSheetTrigger
      v-if="$slots.trigger"
      :aria-label="title"
      :class="triggerClass"
      @click.stop
    >
      <slot name="trigger" />
    </UiSheetTrigger>
    <UiSheetContent
      side="bottom"
      hide-close
      class="flex max-h-sheet flex-col gap-0 overflow-hidden p-0"
    >
      <div class="flex shrink-0 items-center justify-between border-b p-4">
        <UiSheetTitle class="text-pretty text-xl font-semibold lg:text-2xl">{{ title }}</UiSheetTitle>
        <UiSheetDescription class="sr-only">{{ title }}</UiSheetDescription>
        <UiSheetClose
          v-if="!hideClose"
          :aria-label="closeLabel"
        >
          <X
            class="h-5 w-5"
            aria-hidden="true"
          />
        </UiSheetClose>
      </div>
      <div :class="cn('flex min-h-0 flex-1 flex-col overflow-y-auto p-4', contentClass)">
        <slot />
      </div>
      <div class="flex shrink-0 items-center border-t p-4">
        <slot name="footer">
          <UiSheetClose as-child>
            <UiButton
              variant="secondary"
              color="gray"
              class="w-full"
            >
              {{ closeLabel }}
            </UiButton>
          </UiSheetClose>
        </slot>
      </div>
    </UiSheetContent>
  </UiSheet>
</template>
